// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".navigation-button[data-v-459fcf92]{background-color:#fff;color:#4caf50;border:1px solid #4caf50;padding:5px 10px;margin:5px;border-radius:5px;transition:background-color .3s,color .3s}.navigation-button[data-v-459fcf92]:hover{background-color:#4caf50;color:#fff}.navigation-button[data-v-459fcf92]:focus{outline:none}.left-button[data-v-459fcf92],.right-button[data-v-459fcf92]{width:40px;height:40px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
